(function() {
    'use strict';

    // angular
    //     .module('in-out-rm')
    //     .controller('staticPageController', staticPageController);

    // staticPageController.$inject = ['$rootScope', '$scope', '$http', 'staticPageData', '$state', '$sce', '$compile','$filter','$timeout'];

    // function staticPageController($rootScope, $scope, $http, staticPageData, $state, $sce, $compile,$filter,$timeout) {
    //     $scope.content = "";        
    //     window.dynamicpageBuilder = {};
    //     $rootScope.mainLoader = false;
    //     $scope.loading = true;
    //     //Activate Function
    //     activate();

    //     function activate() {
    //         if (angular.isDefined(staticPageData.data.data) && angular.isDefined(staticPageData.data.data.content)) {
    //             var page = staticPageData.data.data;
    //             $scope.page  = page;
    //             if (page && page.metadata && page.metadata.isIframeContent===true) {
    //                 $scope.content = staticPageData.data.data.content;
    //                 $timeout(function(){
    //                     $timeout(function(){
    //                         document.querySelector('#staticPageIframe').contentDocument.write($scope.content);
    //                         iframeLoaded(10);                        
    //                         iframeLoaded(1010);                        
    //                         iframeLoaded(2010);                        
    //                         iframeLoaded(4010);                        
    //                         iframeLoaded(6010);                        
    //                         iframeLoaded(8010); 
    //                     },20);                          

    //                     $timeout(function(){
    //                         $scope.loading = false;
    //                     },3000);                  
    //                 },10);
    //             }
    //             else{
    //                 $scope.loading = false;
    //                 $scope.content = $sce.trustAsHtml(staticPageData.data.data.content);
    //                 console.log("startcall");
    //                 $scope.$watch(function() {
    //                     return window.dynamicpageBuilder;
    //                 }, function(value) {
    //                     $scope.dynamicpageBuilder = value;
    //                     dynamicConfiguration();
    //                 });                    
    //             }
    //         } else {
    //             $state.go("inapp.404");
    //             return;
    //         }

    //     }

    //     function dynamicConfiguration() {
    //         if (typeof $scope.dynamicpageBuilder != "undefined") {
    //             $filter('evalObj')($scope.dynamicpageBuilder);
    //             // evalObj($scope.dynamicHeader);
    //             return $scope.dynamicHeader;
    //         }
    //         return;
    //     }

    //     function iframeLoaded(timeout) {
    //         $timeout(function(){
    //             var iFrameID = document.getElementById('staticPageIframe');
    //             if(iFrameID) {
    //                 // here you can make the height, I delete it first, then I make it again
    //                 iFrameID.height = "";
    //                 iFrameID.height = iFrameID.contentWindow.document.body.scrollHeight + "px";
    //             }                     
    //         },timeout);              
    //     }

    // }

})();